import React, { PropsWithChildren } from "react";
//#region types
import { CommentsViewProps } from "models/propTypes/commentViewPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import AccordionPanel from "../panels/accordianPanel";
import SubmitInput from "../submitInput";
import Comments from "./comments";
import { Grid, Divider } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const CommentsView: React.FC<PropsWithChildren<CommentsViewProps>> = (props) => {
  const {
    title,
    addCommentHandler,
    addCommentPlaceholderText,
    addCommentDescription,
    totalComments,
    defaultExpanded,
    ...commentsProps
  } = props;

  return (
    <AccordionPanel
      title={title ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Events)}
      titleExtraText={
        totalComments
          ? `${totalComments.toString()} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Pc)}`
          : ""
      }
      defaultExpanded={defaultExpanded}
    >
      <Grid container className={cssExports.commentsPanelContent}>
        {addCommentHandler ? (
          <>
            <Grid container id="commentInput">
              <SubmitInput
                label={
                  addCommentPlaceholderText ??
                  LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Comment)
                }
                rootClass={cssExports.addComment}
                buttonIcon={IconDefinitionConstants.WPaperPlane}
                buttonClass={cssExports.commentsInputButton}
                buttonText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit)}
                handleSubmit={props.addCommentHandler!}
                icon={IconDefinitionConstants.WCommentDots}
              />
            </Grid>
            {addCommentDescription ? (
              <Grid className={cssExports.commentInputDescriptionText}>
                <span>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.GenericComments.InfoText)}</span>
              </Grid>
            ) : (
              <></>
            )}
            <Grid item container className={cssExports.dividerContainer}>
              <Divider className={cssExports.dividerGray} />
            </Grid>
          </>
        ) : (
          <></>
        )}
        <Comments {...commentsProps} />
        {props.children}
      </Grid>
    </AccordionPanel>
  );
};

export default CommentsView;
